"use client";

import { faSquare, faSquareCheck } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FieldInputProps } from "formik";
import React, { useState } from "react";
import type { DetailedHTMLProps, InputHTMLAttributes } from "react";

import camelCaseToKebab from "@shared/functions/camelCaseToKebab";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "name"> & {
  field?: FieldInputProps<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
  >;
  label: string;
  name: string;
};

export default function Checkbox({ checked, label, ...props }: Props) {
  const [isChecked, setIsChecked] = useState(checked);

  if (!props.id) {
    props.id = camelCaseToKebab(props.name);
  }

  return (
    <div className="checkbox-wrapper">
      <input
        type="checkbox"
        className={`form__input form__input_type_checkbox`}
        defaultChecked={isChecked}
        required
        {...props}
      />
      <FontAwesomeIcon
        icon={isChecked ? faSquareCheck : faSquare}
        height={18}
        width={16}
        onClick={() => setIsChecked(!isChecked)}
      />
      <label htmlFor={props.id} onClick={() => setIsChecked(!isChecked)}>
        {label}
      </label>
    </div>
  );
}
